import React, { useEffect, useRef } from "react";

const PreLoadingImages = ({ images }) => {
  const preloadedRef = useRef(new Set());
  
  useEffect(() => {
    // Only preload images that haven't been preloaded before
    images.forEach((image) => {
      if (!preloadedRef.current.has(image)) {
        const img = new Image();
        img.src = image;
        preloadedRef.current.add(image);  
      }
    });
  }, [images]);

  return null;
};

export default PreLoadingImages;